module.exports = __webpack_public_path__ + "img/dfm-mark-color.fcdf352.svg";